// @generated by protobuf-ts 2.11.1 with parameter optimize_code_size,long_type_number
// @generated from protobuf file "bianka/enums/listing/filter/source_type.proto" (package "bianka.enums.listing.filter", syntax proto3)
// tslint:disable
/**
 * @generated from protobuf enum bianka.enums.listing.filter.SourceType
 */
export enum SourceType {
    /**
     * @generated from protobuf enum value: SOURCE_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: SOURCE_TYPE_DROPDOWN_FILTERS = 1;
     */
    DROPDOWN_FILTERS = 1,
    /**
     * @generated from protobuf enum value: SOURCE_TYPE_VISUAL_FILTERS = 2;
     */
    VISUAL_FILTERS = 2,
    /**
     * @generated from protobuf enum value: SOURCE_TYPE_TOGGLES = 3;
     */
    TOGGLES = 3,
    /**
     * @generated from protobuf enum value: SOURCE_TYPE_FLP_TAGS = 4;
     */
    FLP_TAGS = 4,
    /**
     * @generated from protobuf enum value: SOURCE_TYPE_SELLER_SPEAKS_YOUR_LANGUAGE_SEE_MORE_BUTTON = 5;
     */
    SELLER_SPEAKS_YOUR_LANGUAGE_SEE_MORE_BUTTON = 5,
    /**
     * @generated from protobuf enum value: SOURCE_TYPE_DRAWER = 6;
     */
    DRAWER = 6
}
